<template>
  <div class="dsfa-sc-area-ware">
    <DsfSCPanel title="各系统入库数据情况" :iconUrl="iconUrl">
      <div class="dsfa-sc-area-informant-table-wrap">
        <table class="dsfa-sc-table">
          <thead class="dsfa-sc-thead">
            <th class="dsfa-sc-thead-th">系统名称</th>
            <th class="dsfa-sc-thead-th">当年数据量</th>
            <th class="dsfa-sc-thead-th">累计数据量</th>
          </thead>
          <tbody class="dsfa-sc-tbody">
            <tr class="dsfa-sc-tbody-tr" v-for="(item, index) in list" :key="index">
              <td class="dsfa-sc-tbody-td">
                {{ item.name }}
              </td>
              <td class="dsfa-sc-tbody-td">
                <div class="dsfa-sc-tbody-td-data">
                  <DsfSCCountTo :num="item.currentData"></DsfSCCountTo>
                  <span class="unit">条</span>
                </div>
              </td>
              <td class="dsfa-sc-tbody-td">
                <div class="dsfa-sc-tbody-td-data">
                  <DsfSCCountTo :num="item.totalData"></DsfSCCountTo>
                  <span class="unit">条</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </DsfSCPanel>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfSCAreaWare",
  ctrlCaption: "各系统入库数据情况",
  mixins: [$mixins.control],
  data() {
    return {
       iconUrl:require("../../../assets/styles/img/leaderCockpit/icon-gxt.png"),
      list: [],
    };
  },
  components: {},
  created() {
    this.$http.get("/static/data/dsf.scareaware.json").then(({ data }) => {
      this.list = data;
    });
  },
  methods: {},
});
</script>

<style lang="scss">
@import '_statistics-cloud/assets/styles/pc/areaWare.scss';
</style>